module.exports = __webpack_public_path__ + "static/paquete-3-85edc1485fae933c275b8df8dc8a6ad8.svg";